import React, { useState } from 'react';
import { BellIcon, PlusIcon, InfoIcon } from 'lucide-react';
const AlertsPage = () => {
  const [alertType, setAlertType] = useState('flight');
  return <div className="container mx-auto px-4 py-8" data-id="element-105">
      <h1 className="text-3xl font-bold mb-2" data-id="element-106">Set Flight Alerts</h1>
      <p className="text-gray-600 mb-8" data-id="element-107">
        Get notified about changes to your flight's status, delays, gate
        changes, and more.
      </p>
      <div className="bg-white rounded-lg shadow-md p-6 max-w-3xl mx-auto" data-id="element-108">
        <div className="flex space-x-4 mb-6" data-id="element-109">
          <button className={`px-4 py-2 rounded-md ${alertType === 'flight' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`} onClick={() => setAlertType('flight')} data-id="element-110">
            Flight Number
          </button>
          <button className={`px-4 py-2 rounded-md ${alertType === 'route' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`} onClick={() => setAlertType('route')} data-id="element-111">
            Route
          </button>
        </div>
        <form data-id="element-112">
          {alertType === 'flight' ? <div className="mb-4" data-id="element-113">
              <label htmlFor="flightNumber" className="block text-gray-700 mb-2" data-id="element-114">
                Flight Number
              </label>
              <input type="text" id="flightNumber" placeholder="e.g. AA1234, DL5678" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-115" />
              <p className="text-sm text-gray-500 mt-1" data-id="element-116">
                Enter the airline code followed by the flight number
              </p>
            </div> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-117">
              <div data-id="element-118">
                <label htmlFor="departure" className="block text-gray-700 mb-2" data-id="element-119">
                  From
                </label>
                <input type="text" id="departure" placeholder="Airport or city" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-120" />
              </div>
              <div data-id="element-121">
                <label htmlFor="arrival" className="block text-gray-700 mb-2" data-id="element-122">
                  To
                </label>
                <input type="text" id="arrival" placeholder="Airport or city" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-123" />
              </div>
            </div>}
          <div className="mb-4" data-id="element-124">
            <label htmlFor="date" className="block text-gray-700 mb-2" data-id="element-125">
              Date
            </label>
            <input type="date" id="date" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-126" />
          </div>
          <div className="mb-6" data-id="element-127">
            <h3 className="text-lg font-medium mb-3" data-id="element-128">Alert Types</h3>
            <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-4" data-id="element-129">
              <div className="flex items-start" data-id="element-130">
                <InfoIcon className="h-5 w-5 text-blue-500 mt-0.5 mr-2" data-id="element-131" />
                <p className="text-sm text-blue-700" data-id="element-132">
                  Select the types of alerts you want to receive. You can change
                  these settings anytime.
                </p>
              </div>
            </div>
            <div className="space-y-3" data-id="element-133">
              {alertOptions.map(option => <div key={option.id} className="flex items-center" data-id="element-134">
                  <input type="checkbox" id={option.id} defaultChecked={option.defaultChecked} className="h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500" data-id="element-135" />
                  <label htmlFor={option.id} className="ml-3 text-gray-700" data-id="element-136">
                    {option.label}
                  </label>
                </div>)}
            </div>
          </div>
          <div className="mb-6" data-id="element-137">
            <h3 className="text-lg font-medium mb-3" data-id="element-138">Notification Methods</h3>
            <div className="space-y-3" data-id="element-139">
              <div className="flex items-center" data-id="element-140">
                <input type="checkbox" id="email" defaultChecked className="h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500" data-id="element-141" />
                <label htmlFor="email" className="ml-3 text-gray-700" data-id="element-142">
                  Email
                </label>
              </div>
              <div className="flex items-center" data-id="element-143">
                <input type="checkbox" id="sms" className="h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500" data-id="element-144" />
                <label htmlFor="sms" className="ml-3 text-gray-700" data-id="element-145">
                  SMS
                </label>
              </div>
              <div className="flex items-center" data-id="element-146">
                <input type="checkbox" id="push" className="h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500" data-id="element-147" />
                <label htmlFor="push" className="ml-3 text-gray-700" data-id="element-148">
                  Push Notification
                </label>
              </div>
            </div>
          </div>
          <div data-id="element-149">
            <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-md transition-colors flex items-center justify-center" data-id="element-150">
              <BellIcon className="h-5 w-5 mr-2" data-id="element-151" />
              Create Alert
            </button>
          </div>
        </form>
      </div>
    </div>;
};
const alertOptions = [{
  id: 'status',
  label: 'Flight Status Changes (Delayed, Cancelled, Diverted)',
  defaultChecked: true
}, {
  id: 'gate',
  label: 'Gate Changes',
  defaultChecked: true
}, {
  id: 'departure',
  label: 'Departure Time Updates',
  defaultChecked: true
}, {
  id: 'arrival',
  label: 'Arrival Time Updates',
  defaultChecked: true
}, {
  id: 'baggage',
  label: 'Baggage Claim Information',
  defaultChecked: false
}, {
  id: 'weather',
  label: 'Weather Alerts Affecting Flight',
  defaultChecked: false
}];
export default AlertsPage;